module.exports = __webpack_public_path__ + "img/money-bill-solid.696cfec0.svg";